import React, { MouseEvent } from "react";
import { RequisitionRow } from "../../recoil/types";
import {
  CfcGridBanner,
  CfcGridBannerActions,
  CfcGridBannerMessage,
  CfcGridBannerOrderButton,
  CfcGridBannerStrong,
} from "./CfcRowBanner.styles";
import { formatCfcCollectByDate } from "./cfcGridUtils";

interface CfcRowBannerProps {
  row: RequisitionRow;
  onOrderCfc: (row: RequisitionRow) => void;
}

const stopRowEvents = (event: MouseEvent) => {
  event.preventDefault();
  event.stopPropagation();
};

const getCfcDeadlineMessage = (collectByDate: string): string =>
  `Test order and additional blood draw must be completed no later than ${collectByDate}`;

export const CfcRowBanner = ({
  row,
  onOrderCfc,
}: CfcRowBannerProps): React.ReactElement => {
  const collectByDate = formatCfcCollectByDate(row.cfcEligibleCollectByDate);

  return (
    <CfcGridBanner onClick={stopRowEvents} onMouseDown={stopRowEvents}>
      <CfcGridBannerMessage>
        <span>
          Eligible for Unity Confirm, circulating fetal cell confirmatory
          testing.{" "}
          <CfcGridBannerStrong>
            {getCfcDeadlineMessage(collectByDate)}
          </CfcGridBannerStrong>
        </span>
      </CfcGridBannerMessage>
      <CfcGridBannerActions>
        <CfcGridBannerOrderButton
          onClick={(event) => {
            stopRowEvents(event);
            onOrderCfc(row);
          }}
        >
          Order Test
        </CfcGridBannerOrderButton>
      </CfcGridBannerActions>
    </CfcGridBanner>
  );
};
